const defaultRender = (value) => (value ? value : "--");

const clientListColumns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Mobile No",
    dataIndex: "mobile_no",
    render: defaultRender,
  },
  {
    title: "Login Type",
    dataIndex: "login_type",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: (value) => (value ? new Date(value).toLocaleDateString() : "--"),
  },
];

export default clientListColumns;
